<script lang="typescript">
  import { RouteNames, RouteSystem } from "../systems";
  import { onMount } from "svelte";
  import * as Store from "../services/store.service";
  import * as Api from "../services/api.service";
  import { LogoIcon } from "../components/icons";
  import AppPackage from "../../package.json";
  import * as DrawerSystem from "shared/systems/drawer.system";
  import Loader from "shared/loader.svelte";

  let status = "Loading...";

  const sleep = (n: number) =>
    new Promise((resolve, reject) => setTimeout(resolve, n));

  onMount(async () => {
    // For now, we just gave gertec binary
    // some time (2s) to write report.json before loading ...
    // setReport(project, script, feature, scenario, step, statistics, kind);
    status = "Updating store...";

    await sleep(1000);

    // const allRootFolders = Store.DataStore.rootFolders;

    // // we need to build the index for all root Folders
    // for (let rootFolder of allRootFolders) {
    //   status = `Creatinng search index for [${rootFolder.alias}] folder...`;
    //   // build a search index...
    //   await Api.createSearchIndex(rootFolder);
    //   await sleep(1000);
    // }
    // // declaração

    RouteSystem.push(RouteNames.Rules);
    DrawerSystem.setState("collapsed");
  });
</script>

<div class="init">
  <div class="loader">
    <LogoIcon color="var(--color-primary)" width={256} height={256} />
    <h1 class="title">Jack Tech</h1>
    <Loader color="var(--color-level-7)" />

    <span class="status">{status}</span>
    <span class="version">Version:{AppPackage.version}</span>
  </div>
</div>

<style>
  .init {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    background-color: var(--color-level-0);
  }
  .loader {
    color: var(--color-level-5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .title {
    font-size: 48px;
    font-weight: 700;
    padding: 20px;
    color: var(--color-primary);
  }

  .status {
    font-weight: 400;
    font-size: 14px;
    padding: 20px 0;
    color: var(--color-level-6);
  }
  .version {
    font-size: 14px;
  }
</style>
